import React from 'react';
import { motion } from 'framer-motion';
import { Target, Repeat, Timer, Pencil } from 'lucide-react';
export function Slide08Metrics() {
  const guardrails = [{
    icon: Repeat,
    metric: '+15%',
    label: '90-day retention',
    note: 'Primary business outcome we expect to move.'
  }, {
    icon: Timer,
    metric: '< 2 min',
    label: 'Time to build a cart',
    note: 'Down from a 28-minute weekly average.'
  }, {
    icon: Pencil,
    metric: '≤ 40%',
    label: 'Plan edit rate',
    note: 'Guardrail — high edits signal poor recommendations.'
  }];
  return <div className="w-full h-full flex flex-col justify-center px-[clamp(4rem,8vw,10rem)] relative" data-id="element-256">
      <div className="absolute bottom-0 left-0 w-full h-1/3 bg-[var(--surface-alt)]/20 -z-10" data-id="element-257" />

      <motion.div initial={{
      opacity: 0,
      x: -20
    }} animate={{
      opacity: 1,
      x: 0
    }} className="mb-14" data-id="element-258">
        <div className="flex items-center gap-4 mb-6" data-id="element-259">
          <div className="h-px w-12 bg-[var(--accent)]" data-id="element-260" />
          <span className="text-[var(--accent)] font-semibold tracking-widest uppercase text-sm" data-id="element-261">
            How We'll Measure Success
          </span>
        </div>
        <h2 className="font-display text-[clamp(3rem,4.5vw,5rem)] leading-[1.1]" data-id="element-262">
          One north star, three guardrails.
        </h2>
      </motion.div>

      <div className="flex flex-col lg:flex-row gap-10 max-w-6xl w-full" data-id="element-263">
        {/* North star */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.15,
        type: 'spring',
        stiffness: 150,
        damping: 20
      }} className="flex-1 bg-[var(--fg)] text-[var(--bg)] p-12 rounded-[3rem] relative overflow-hidden flex flex-col justify-center shadow-2xl shadow-[var(--fg)]/20" data-id="element-264">
          <div className="absolute -top-10 -right-10 p-8 opacity-10" data-id="element-265">
            <Target size={200} strokeWidth={0.5} data-id="element-266" />
          </div>
          <div className="relative z-10" data-id="element-267">
            <div className="inline-block px-4 py-2 bg-[var(--bg)]/10 rounded-full text-xs font-bold tracking-widest uppercase mb-8 backdrop-blur-sm" data-id="element-268">
              North Star Metric
            </div>
            <h3 className="font-display text-[clamp(2rem,3vw,3.5rem)] leading-[1.1] mb-6" data-id="element-269">
              Weekly plans activated per subscriber
            </h3>
            <p className="text-lg opacity-80 leading-relaxed font-medium max-w-md" data-id="element-270">
              If subscribers keep activating an AI-built plan each week, the
              feature is delivering durable value.
            </p>
          </div>
        </motion.div>

        {/* Guardrails */}
        <div className="flex-1 flex flex-col gap-6" data-id="element-271">
          {guardrails.map((g, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.25 + i * 0.15,
          type: 'spring',
          stiffness: 150,
          damping: 20
        }} className="flex-1 bg-[var(--surface)] p-8 rounded-[2.5rem] border border-[var(--surface-alt)] flex items-center gap-8 shadow-sm hover:shadow-md transition-shadow" data-id="element-272">
              <div className="w-16 h-16 rounded-2xl bg-[var(--surface-alt)]/50 flex items-center justify-center shrink-0 text-[var(--accent)]" data-id="element-273">
                <g.icon size={32} strokeWidth={1.5} data-id="element-274" />
              </div>
              <div data-id="element-275">
                <div className="flex items-baseline gap-4 mb-1" data-id="element-276">
                  <span className="font-display text-4xl text-[var(--fg)]" data-id="element-277">
                    {g.metric}
                  </span>
                  <span className="font-semibold text-xl text-[var(--fg-muted)]" data-id="element-278">
                    {g.label}
                  </span>
                </div>
                <p className="text-[var(--fg-muted)]/80 text-base" data-id="element-279">{g.note}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </div>;
}